import React from 'react';
import { useCommonMessagesQuery } from '@framework/content/get-common-message';
import { useTranslation } from 'next-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { BorderBeam } from '@components/ui/border-beam';
const MotionButton = motion(Button);
const MotionBorderBeam = motion(BorderBeam);
const containerVariants = {
  hidden: {
    opacity: 0,
    y: -50
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  },
  exit: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.5
    }
  }
};
const CommonMessageHome: React.FC = () => {
  const {
    data,
    isLoading,
    error
  } = useCommonMessagesQuery();
  const {
    t
  } = useTranslation();
  if (isLoading) return <h1></h1>;
  if (error || !data || data.length === 0) return null;
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="CommonMessageHome" data-sentry-source-file="common-message-home.tsx">
      <motion.div className="relative flex flex-col gap-2 items-center justify-center text-foreground dark:text-neutral-200 p-2 bg-neutral-50 dark:bg-zinc-950 border border-neutral-200 dark:border-neutral-800 rounded-2xl mx-4 mb-10" variants={containerVariants} initial="hidden" animate="visible" exit="exit" data-sentry-element="unknown" data-sentry-source-file="common-message-home.tsx">
        {data.map((msg, index) => <React.Fragment key={msg.id}>
            <motion.div className="flex flex-row items-center gap-2">
              <motion.h1 className="flex-1 text-xs md:text-lg text-center dark:text-neutral-200" variants={containerVariants}>
                {msg.message}
              </motion.h1>
              {msg.url && <MotionButton onClick={() => window.open(msg.url!, '_blank', 'noopener,noreferrer')} className="px-4 py-2 text-xs rounded-full" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }}>
                  {t('common:text-learn-more')}
                </MotionButton>}
              {msg.file && <MotionButton onClick={() => window.open(msg.file!, '_blank', 'noopener,noreferrer')} className="px-4 py-2 text-xs rounded-full" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }}>
                  {t('common:button-view')}
                </MotionButton>}
            </motion.div>
            {index !== data.length - 1 && <hr className="w-full border-neutral-200 dark:border-neutral-800" />}
          </React.Fragment>)}
        {data.length > 1 && <MotionBorderBeam duration={8} size={200} className="absolute top-0 left-1/2 transform -translate-x-1/2" />}
      </motion.div>
    </AnimatePresence>;
};
export default CommonMessageHome;